import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SessionService } from '../../services/session.service';
import { PageComponent } from '../../components/page/page.component';
import { RouteUtil } from 'src/app/general/util/route-util';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationStatus } from '../../util/util';
import { Util } from 'src/app/general/util/util';
import { ActionComponent } from 'src/app/general/components/action/action.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DeviceHeaderComponent } from '../../components/device-header/device-header.component';
import { DeviceRemoteLogsComponent } from '../../components/device-remote-logs/device-remote-logs.component';
import { DialogService } from 'src/app/general/services/dialog.service';
import { BackendService } from '../../services/backend.service';
import { ToastService } from 'src/app/general/services/toast.service';

@Component({
  selector: 'app-device-remote-logs-page',
  standalone: true,
  imports: [
    CommonModule,
    PageComponent,
    DeviceHeaderComponent,
    ActionComponent,
    TranslateModule,
    DeviceRemoteLogsComponent
  ],
  templateUrl: './device-remote-logs-page.component.html',
  styleUrls: ['./device-remote-logs-page.component.css']
})
export class DeviceRemoteLogsPageComponent implements OnInit {

  deviceId: string;

  constructor(
      private sessionService: SessionService,
      private backendService: BackendService,
      private dialogService: DialogService,
      private toastService: ToastService,
      private translateService: TranslateService,
      private activatedRoute: ActivatedRoute) {
    this.deviceId = '';
  }

  ngOnInit(): void {
    if (this.sessionService.enforceAuthentication()
        == AuthenticationStatus.USER_NOT_AUTHENTICATED_AND_REDIRECTED_TO_SIGNIN_PAGE) {
      return;
    }

    const pathParams = RouteUtil.getPathParams(this.activatedRoute);
    this.deviceId = Util.safeString(pathParams.get('deviceId'));
  }

  public capture5MinRemoteLogs(): void {
    const closeProgressDialog = this.dialogService.openProgressDialog();
    this.backendService.startRemoteLogsSession(
      this.deviceId,
      /* durationSeconds= */ 5 * 60,
      /* onSuccess= */ () => {
        closeProgressDialog();
      },
      /* onError */ error => {
        closeProgressDialog();
        this.translateService.get('error_internal').subscribe(text => this.toastService.error(error.addErrorDetails(text)));
      }
    );
  }
}
